{
  "it": {
    "texts": {
      "user": {
        "maintainer": "Riceve il badge di manutentore e tutti i vantaggi del livello più alto di sostegno."
      },
      "index": "Il tuo database per tutte le informazioni su Navi e Stazioni in Star Citizen.",
      "support": {
        "info": "Niente budget? <a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>Votaci su Spectrum</b></a> per far scoprire FleetYards a più persone.",
        "goal": "Copre i costi correnti come hosting dei server e servizi dati.",
        "code": "Nuovo su Star Citizen? Usa questo codice per 5000 UEC iniziali:",
        "thisMonth": "su %{goal} questo mese",
        "subline": "Sostienici direttamente",
        "anonymousSupporters": {
          "one": "%{count} sostenitore anonimo",
          "other": "%{count} sostenitori anonimi"
        },
        "otherWays": "Altri modi per aiutare"
      },
      "appUpdate": {
        "withCodename": "FleetYards %{version} (%{codename}) è online. Ricarica per passare alla nuova versione.",
        "plain": "FleetYards %{version} è online. Ricarica per passare alla nuova versione."
      },
      "installApp": {
        "eventSignup": "Installa FleetYards come app per tornare ai tuoi eventi con un tocco.",
        "iosIntro": "Su iPhone e iPad, le app come FleetYards si installano dal menu Condividi:",
        "iosShare": "Tocca il pulsante Condividi nella barra del browser.",
        "iosAdd": "Scegli «Aggiungi alla schermata Home». Potrebbe essere necessario scorrere verso il basso.",
        "iosConfirm": "Tocca «Aggiungi». Ora FleetYards si apre dalla schermata Home come qualsiasi altra app."
      },
      "supportHint": {
        "hangarSync": "Le sincronizzazioni in background sono la voce più grande della nostra bolletta di hosting. FleetYards va avanti grazie alle donazioni — ogni contributo aiuta.",
        "vehicleAdded": "FleetYards è gratuito, senza pubblicità e si sostiene solo con le donazioni. Se ti è utile, un piccolo contributo aiuta a mantenerlo così.",
        "fleetCreated": "Le flotte sono tra le funzioni più impegnative. FleetYards resta gratuito e senza pubblicità grazie alle donazioni — valuta di contribuire.",
        "loginMilestone": "Sei con noi da un po' — grazie. FleetYards si sostiene con le donazioni; se vuoi aiutare a coprire i costi, ecco come.",
        "visitMilestone": "FleetYards è finanziato dalla community — niente pubblicità, niente paywall. Se ti è utile, una piccola donazione fa molto."
      },
      "notFound": "Attualmente stai avventurando uno spazio sconosciuto. In caso di smarrimento, l'UEE raccomanda vivamente di tracciare una nuova destinazione di nuovo verso lo spazio di casa.",
      "forbidden": "La tua autorizzazione non copre quest'area. Se una funzione è ancora in distribuzione, potrai attivarla tu stesso in Impostazioni > Funzioni non appena sarà disponibile.",
      "subscriptionRequired": "Contratti, eventi, logistics e spedizioni sono sostenuti da chi supporta FleetYards. Questa flotta al momento non è coperta: il contributo di un solo membro apre tutte e quattro per l'intera flotta.",
      "featureNotReady": "Questa funzione non è ancora pronta e sarà disponibile a breve. Resta sintonizzato!",
      "inviteInvalid": "Questo link di invito non è valido. Potrebbe essere stato copiato male, potrebbe essere scaduto oppure potrebbe aver già raggiunto il limite di utilizzi. Chiedi un nuovo link a chi ti ha invitato.",
      "accessDenied": "Non sei autorizzato a visualizzare questa pagina.",
      "serverError": "Il server sta riscontrando difficoltà tecniche. Riprova più tardi.",
      "offline": "La richiesta non ha raggiunto il server. Il tuo dispositivo sembra essere offline oppure il server non è raggiungibile. Controlla la connessione e riprova.",
      "invalidRequest": "Il server non è riuscito a elaborare questa richiesta. Ricarica la pagina e riprova.",
      "invalidListRequest": "Questo filtro o ordinamento non è valido. Reimpostalo per visualizzare di nuovo l'elenco.",
      "compare": {
        "ships": {
          "info": "Per iniziare a selezionare almeno due e non più di otto Navi che si desiderano confrontare."
        },
        "components": {
          "info": "Seleziona fino a otto componenti della stessa categoria, come scudi o motori quantici, per confrontarli fianco a fianco."
        },
        "equipment": {
          "info": "Seleziona fino a otto pezzi di equipaggiamento dello stesso tipo, come fucili o caschi, per confrontarli fianco a fianco."
        },
        "dropped": "Rimosso %{items}: questo confronto contiene una sola categoria, %{category}."
      },
      "fleets": {
        "leaveInfo": "Non puoi lasciare una flotta come amministratore.",
        "directory": "Flotte verificate che hanno scelto di farsi trovare. Ogni flotta qui ha dimostrato di guidare la propria organizzazione RSI."
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "Il ripristino di una flotta eliminata definitivamente è parziale. Ruoli, immagini, link di invito e veicoli della flotta non vengono ripristinati."
        },
        "models": {
          "viewsFolder": {
            "hint": "Trascina una cartella di viste chiamate top.png, side.png, front.png e angled.png. Suffisso _colored per il set verniciato, prefisso extended_ per quello esteso e landed_ per quello atterrato. Il prefisso flight_, o nessun prefisso, finisce nel set predefinito. Anche holo.gltf viene incluso, con gli stessi prefissi. Le viste da dietro e dal basso si chiamano angled_rear.png, bottom.png, rear.png e starboard.png. holo_lite.glb, l'holo senza interni, accetta gli stessi prefissi; holo_textured.glb finisce solo nel set predefinito, così come holo.usdz, l'holo per la RA su iPhone e iPad.",
            "uploading": {
              "one": "Caricamento di un file…",
              "other": "Caricamento di %{count} file…"
            },
            "matched": {
              "one": "Un file pronto — salva per applicarlo.",
              "other": "%{count} file pronti — salva per applicarli."
            },
            "processing": {
              "one": "Ritaglio di una vista in background — si aggiornerà qui al termine.",
              "other": "Ritaglio di %{count} viste in background — si aggiorneranno qui al termine."
            },
            "processed": "Tutte le viste sono state elaborate.",
            "ignored": "Ignorati: %{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "Il motivo viene mostrato a chi ha registrato l'applicazione, quindi indica cosa deve cambiare."
        }
      },
      "hangarTour": {
        "welcome": {
          "title": "Benvenuto nel tuo hangar",
          "text": "Il tuo hangar tiene traccia di ogni nave che possiedi. Questo breve tour ti mostra dove si trova tutto — puoi riavviarlo dal pulsante ? in qualsiasi momento."
        },
        "add": {
          "title": "Aggiungi navi",
          "text": "Scegli una o più navi e quante di ciascuna. Nella pagina o nella scheda di ogni nave, l'icona del segnalibro la aggiunge anche al tuo hangar o alla tua lista dei desideri."
        },
        "sync": {
          "title": "Sincronizza con RSI",
          "text": "Sincronizza navi, vernici, oggetti decorativi ed equipaggiamento da RSI con l’estensione FleetYards. Controlla il risultato dopo ogni sincronizzazione. I riacquisti si sincronizzano dalla propria pagina."
        },
        "display": {
          "title": "Opzioni di visualizzazione",
          "text": "Passa tra schede ed elenco, imposta l'ordinamento predefinito e scegli quali dettagli o colonne mostrare. Nell'elenco puoi selezionare più navi e modificarle insieme."
        },
        "groups": {
          "title": "Gruppi",
          "text": "Ordina le tue navi in gruppi tuoi con + e la matita. Clicca un gruppo per filtrare, passaci sopra per evidenziarne le navi."
        },
        "vehicle": {
          "title": "Il menu di ogni nave",
          "text": "Modifica una nave da qui: dalle un nome, scegli la vernice, rendila la tua ammiraglia, imposta la visibilità, gestisci i loadout o spostala nella lista dei desideri."
        },
        "wishlist": {
          "title": "Lista dei desideri",
          "text": "Inserisci nella lista dei desideri le navi che vuoi ma non possiedi ancora. Spostale nell’hangar quando le ottieni."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Allinea le tue navi in scala una accanto all'altra e salva il grafico come immagine."
        },
        "pages": {
          "title": "Pagine dell’hangar",
          "text": "Statistiche, lista dei desideri, inventari, progetti e gli oggetti sincronizzati dal tuo hangar RSI hanno ciascuno una pagina nella sezione hangar della navigazione."
        },
        "share": {
          "title": "Condividi il tuo hangar",
          "text": "Condividi il tuo hangar pubblico e scegli quali navi e gruppi mostrare. Nelle impostazioni dell’hangar puoi anche creare, sostituire o disattivare un link segreto che funziona anche se l’hangar è privato. Chiunque abbia il link può vedere il tuo hangar e le sue statistiche."
        },
        "menu": {
          "title": "Altro",
          "text": "Importa o esporta il tuo hangar, consulta la cronologia delle importazioni e apri il tuo hangar RSI. Sul telefono, questo menu contiene anche la lista dei desideri, il fleetchart e questo tour."
        },
        "overview": {
          "title": "La pagina della tua nave",
          "text": "Fai clic sul titolo della nave per aprire la panoramica per gestire configurazione e visibilità, scrivere nel diario del capitano e caricare un’immagine. Aggiungi una targa con dedica a una nave che possiedi e salvala come immagine. Le voci del diario hanno impostazioni di visibilità proprie."
        },
        "reset": {
          "title": "Dopo un azzeramento del gioco",
          "text": "Reimposta qui le navi acquistate nel gioco: spostale tutte nella lista dei desideri come lista della spesa oppure rimuovile dall’hangar. Le navi acquistate con denaro reale rimangono."
        },
        "exampleShip": {
          "title": "Nave di esempio",
          "text": "Solo per il tour. Questa nave non viene salvata nel tuo hangar."
        }
      },
      "fleetTour": {
        "welcome": {
          "title": "La tua flotta è pronta",
          "text": "Questo tour apre ogni pagina in cui si configura e indica ciò che conta in ciascuna. Il punto interrogativo in alto nella pagina della flotta lo riapre in qualsiasi momento."
        },
        "events": {
          "title": "Eventi e missioni",
          "text": "Pianifica operazioni, lascia che i membri si iscrivano per una nave e un posto, e tieni tutto nel calendario della flotta."
        },
        "contracts": {
          "title": "Contratti",
          "text": "Pubblica incarichi per i tuoi membri e pagali quando sono completati."
        },
        "members": {
          "title": "Invita membri",
          "text": "Invita persone tramite il loro nome utente Fleetyards, oppure crea un link di invito da condividere su Discord o RSI. Anche le richieste di adesione arrivano su questa pagina."
        },
        "ships": {
          "title": "Navi e fleetchart",
          "text": "Le navi condivise dai tuoi membri formano insieme quelle della flotta. Il fleetchart le allinea una accanto all'altra in scala."
        },
        "membership": {
          "title": "Le tue navi nella flotta",
          "text": "Ogni membro decide quali delle sue navi vede la flotta: tutte, un gruppo dell'hangar o nessuna. Qui fai la tua scelta."
        },
        "rsi": {
          "title": "Verifica la tua organizzazione RSI",
          "text": "Inserisci il SID della tua organizzazione e verificalo. La verifica dimostra che l'organizzazione è tua e protegge l'ID della tua flotta."
        },
        "roles": {
          "title": "Ruoli",
          "text": "Ogni ruolo decide cosa i suoi membri possono vedere e gestire. Questa pagina mostra cosa può fare ogni ruolo."
        },
        "squadrons": {
          "title": "Squadroni e team",
          "text": "Attiva gli squadroni per dividere i membri in unità e team, ciascuno con i propri gradi."
        },
        "discord": {
          "title": "Collega Discord",
          "text": "Installa il bot sul tuo server Discord per assegnare a ogni grado un ruolo Discord e rispecchiare gli eventi come eventi programmati."
        },
        "settings": {
          "title": "Pagina pubblica della flotta",
          "text": "Decidi se la pagina della flotta e le sue navi sono pubbliche; logo, descrizione e link sono anche qui."
        },
        "finish": {
          "title": "La tua flotta è configurata",
          "text": "È tutto per iniziare. Il punto interrogativo qui in alto riapre questo tour in qualsiasi momento."
        }
      },
      "hangarPreview": {
        "sync": {
          "title": "Sincronizza con RSI",
          "text": "Importa i tuoi pledge con l'estensione del browser o un file hangarXPLOR invece di aggiungere le navi una per una."
        },
        "organise": {
          "title": "Organizza le tue navi",
          "text": "Dai un nome alle tue navi, imposta vernici, loadout e ammiraglia, e ordinale in gruppi tuoi."
        },
        "wishlist": {
          "title": "Lista dei desideri e saldi",
          "text": "Tieni le navi che vuoi in una lista dei desideri e ricevi una notifica quando sono in saldo."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Guarda le tue navi in scala una accanto all'altra e salva il grafico come immagine."
        },
        "stats": {
          "title": "Statistiche dell'hangar",
          "text": "Ruoli, produttori, dimensioni e quanto hai speso, a colpo d'occhio."
        },
        "share": {
          "title": "Hangar pubblico",
          "text": "Condividi il tuo hangar con un link — decidi tu quali navi e gruppi sono visibili."
        }
      },
      "fleetPreview": {
        "members": {
          "title": "Membri e ruoli",
          "text": "Invita i membri della tua org con un link e organizzali con ruoli e squadriglie."
        },
        "ships": {
          "title": "Navi della flotta",
          "text": "Le navi pubbliche di tutti i membri in un'unica lista filtrabile e ricercabile."
        },
        "fleetchart": {
          "title": "Fleetchart",
          "text": "Guarda l'intera flotta in scala una accanto all'altra e salvala come immagine."
        },
        "stats": {
          "title": "Statistiche della flotta",
          "text": "Analizza la tua flotta per ruolo, dimensione e capacità di carico."
        },
        "allies": {
          "title": "Alleati",
          "text": "Alleati con altre flotte e tieni traccia di chi vola con te."
        },
        "discord": {
          "title": "Discord",
          "text": "Pubblica annunci e un riepilogo settimanale sul tuo server Discord e lascia che i membri entrino tramite un ruolo."
        }
      },
      "impressum": {
        "visit": "Visita",
        "ytShipImages": "Le bellissime immagini delle navi nella vista Fleetchart sono il lavoro di <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br> Visitate il suo post Spectrum (vedi link qui sotto) e dategli un voto.",
        "erkul": "Le metriche delle navi su Fleetyards si basano sulle formule e sui valori di Erkul's DPS Calculator. Grazie al team di erkul.games per aver condiviso il proprio lavoro con la comunità.",
        "appSignal": "AppSignal ha fornito un account Open Source sponsorizzato che aiuta a migliorare ulteriormente Fleetyards.net. Grazie :)",
        "copyright": "I contenuti e le opere creati dagli operatori delle pagine, su queste pagine sono soggetti al diritto d'autore tedesco. La duplicazione, il trattamento, la distribuzione e qualsiasi tipo di sfruttamento al di fuori dei limiti del Copyright richiedono il consenso scritto del rispettivo autore o creatore. I download e le copie di questa pagina sono solo per uso privato e non commerciale. Nella misura in cui il contenuto di questa pagina non è stato creato dall'operatore, sono rispettati i diritti d'autore di terze parti, in particolare i contenuti di terze parti in quanto tali. Vi preghiamo di contattarci se notate qualsiasi tipo di violazione del copyright. Rimuoveremo immediatamente qualsiasi contenuto una volta notificati di tali violazioni.",
        "disclaimer": {
          "p1": "Questo è un fansite non ufficiale di Star Citizen, non affiliato con Cloud Imperium e rispettivo gruppo di aziende.",
          "p2": "Tutti i contenuti di questo sito che non sono stati creati dal proprietario del sito o utenti dello stesso sono prerogativa dei rispettivi proprietari.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, e Cloud Imperium® sono marchi registrati di Cloud Imperium Rights LLC. Tutti i diritti riservati."
        },
        "liabilityInternal": {
          "p1": "Il contenuto di fuori sito è stato compilato con cura meticolosa e al meglio delle nostre conoscenze. Tuttavia, non possiamo assumerci alcuna responsabilità riguardo l'aggiornamento, la completezza o l'accuratezza delle pagine.",
          "p2": "Ai sensi della sezione 7, paragrafo 1 del TMG (Telemediengesetz), Siamo responsabili per i nostri contenuti su queste pagine in conformità con le leggi generali. Tuttavia, ai sensi delle sezioni da 8 a 10 del TMG, non siamo tenuti a monitorare le informazioni esterne fornite o memorizzate sul nostro sito. Una volta notificati di una specifica violazione di legge, elimineremo immediatamente il contenuto in questione. Qualsiasi responsabilità in materia può essere assunta solo a partire dal momento in cui la violazione ci viene notificata."
        },
        "liabilityExternal": "Il nostro sito contiene link a siti web di terze parti (“link esterni”). Poiché il contenuto di questi siti non è sotto il nostro controllo, non possiamo assumerci alcuna responsabilità per tali contenuti esterni. In ogni caso, il fornitore di informazioni sui siti collegati è responsabile per il contenuto e l'accuratezza delle informazioni fornite. Al momento in cui i links erano stati creati, non ci era nota alcuna violazione della legge. Nel caso venissimo a conoscenza di una violazione di legge, avremo cura di eliminare immediatamente il link in questione."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "Quali informazioni utilizziamo?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "Come ospite",
          "text": "Come ospite su %{app} raccogliamo i seguenti dati:"
        },
        "analytics": {
          "headline": "Analisi di utilizzo",
          "basis": "%{app} conta le visualizzazioni di pagina per capire quali parti del sito vengono effettivamente usate. Lo facciamo sulla base del nostro legittimo interesse a gestire e migliorare il sito, non del consenso: i dati sono raccolti solo in prima persona, gli indirizzi IP vengono resi anonimi prima di essere memorizzati, nessun cookie o altro identificatore viene installato sul tuo dispositivo e nulla viene condiviso con reti pubblicitarie.",
          "retention": "Le singole visite e visualizzazioni di pagina vengono eliminate dopo un mese. Oltre quel termine restano solo conteggi aggregati, che non possono essere ricondotti a una persona. L'unica eccezione è un singolo numero sul tuo account: per quante settimane consecutive lo hai usato, contate a ritroso dalla tua visita più recente. L'attività precedente a questa serie non viene conservata e il numero torna a zero quando ti opponi. Anche l'eliminazione del tuo account elimina le visite registrate per esso.",
          "objection": {
            "headline": "Come opporsi",
            "text": "Puoi opporti in qualsiasi momento alle analisi di utilizzo: smetteremo di registrarle, non ci limiteremo a nasconderle.",
            "user": "L'impostazione del tuo account, in Impostazioni, si applica a ogni dispositivo da cui accedi.",
            "guest": "Senza un account puoi opporti qui. Rispettiamo anche il segnale Global Privacy Control, se il tuo browser lo invia."
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "Conta in forma anonima le pagine che visiti, senza memorizzare nulla sul tuo dispositivo. Le visite vengono eliminate dopo un mese.",
          "onlineStatus": "Mostra ai membri delle tue flotte e ai tuoi amici un punto accanto al tuo nome finché hai FleetYards aperto. La tua ultima attività resta comunque visibile.",
          "supporterListed": "Se il tuo nome utente — mai il nome usato per pagare — compare nella pagina dei sostenitori. Le donazioni nascoste contano comunque per l'obiettivo, e i contributi Patreon restano nascosti finché non li mostri."
        },
        "notifications": {
          "hint": "Scegli come ricevere ogni evento. Le notifiche dell'app vengono raccolte nel tuo centro notifiche, le email vanno all'indirizzo del tuo account.",
          "push": {
            "title": "Notifiche push",
            "intro": "Ricevi notifiche su questo dispositivo anche quando FleetYards è chiuso. Scegli quali arrivano come push nella colonna Push qui sotto.",
            "unsupported": "Questo browser non può ricevere notifiche push. Su iPhone o iPad, aggiungi prima FleetYards alla schermata Home e aprilo da lì.",
            "denied": "Le notifiche di FleetYards sono bloccate in questo browser. Consentile nelle impostazioni del sito del browser, poi ricarica questa pagina.",
            "on": "Le notifiche push sono attive su questo dispositivo.",
            "off": "Le notifiche push sono disattivate su questo dispositivo.",
            "device": "%{browser} su %{os}",
            "unknownDevice": "Browser sconosciuto",
            "thisDevice": "(questo dispositivo)",
            "failed": "Non è stato possibile verificare le notifiche push su questo dispositivo. Ricarica la pagina per riprovare."
          }
        }
      },
      "signup": {
        "blocked": "Sei stato bloccato da FleetYards.net.<br>Questo può avere molteplici motivi.<br>Per ulteriori informazioni, ti preghiamo di contattarci su info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "Questo elemento è stato rimosso dalla Roadmap. Questa è la sua ultima posizione"
      },
      "twoFactor": {
        "backupCodes": "Salva una copia dei tuoi codici di backup. Saranno visibili solo questa volta.",
        "disable": "Per disabilitare l'autenticazione a due fattori basta inserire un Token valido.",
        "enable": " Per proteggere il tuo account FleetYards.net puoi generare Token per l'autenticazione a due fattori con Google Authenticator, 1Password o Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} sta richiedendo l'accesso al tuo account.",
        "scopesIntro": "Questa applicazione potrà:"
      },
      "buybackSync": {
        "info": "Legge ogni pagina della tua lista di riacquisto RSI e sostituisce con essa i pledge riacquistabili salvati su Fleetyards. Il tuo hangar non viene modificato. Le liste lunghe richiedono qualche minuto. La sincronizzazione avviene in background: puoi chiudere questa finestra e continuare a usare Fleetyards finché la scheda resta aperta.",
        "unsupported": "La tua estensione Fleetyards Sync non può ancora leggere i pledge riacquistabili. Aggiornala per sincronizzarli.",
        "detailsInfo": "La prima sincronizzazione legge anche il prezzo e l'assicurazione di ogni pledge, una pagina RSI ciascuno, e con una lista lunga può richiedere un quarto d'ora. Le successive leggono solo quelli nuovi.",
        "detailsUnsupported": "Aggiorna la tua estensione Fleetyards Sync per leggere anche prezzi e assicurazioni.",
        "detailsIncomplete": "Alcuni prezzi non sono stati letti da RSI. La prossima sincronizzazione riproverà.",
        "detailsBackground": "Prezzi e assicurazioni vengono ora letti in background. Puoi chiudere questa finestra e continuare a usare Fleetyards; tieni aperta questa scheda finché non ha finito.",
        "detailsRunning": "Prezzi e assicurazioni dell'ultima sincronizzazione sono ancora in lettura. Potrai avviare una nuova sincronizzazione quando sarà terminata.",
        "sessionHint": "La sincronizzazione legge la tua lista di riacquisto tramite questa sessione.",
        "pointReplace": "Legge ogni pagina della tua lista di riacquisto RSI e sostituisce con essa i pledge riacquistabili salvati qui.",
        "pointUntouched": "Il tuo hangar non viene modificato.",
        "pointBackground": "Viene eseguita in background: puoi chiudere questa finestra, basta lasciare aperta la scheda.",
        "finished": "I tuoi pledge riacquistabili corrispondono alla tua lista RSI.",
        "keepsRunning": "Continua anche se chiudi questa finestra. Lascia aperta la scheda finché non termina."
      },
      "blueprintAddToHangar": {
        "ownHint": "Hai questo progetto.",
        "wishlistHint": "Vuoi ottenere questo progetto.",
        "unownHint": "Non hai più questo progetto.",
        "unwantHint": "Non vuoi più questo progetto."
      },
      "addToHangar": {
        "hangarHint": "Possiedi questa nave.",
        "wishlistHint": "Vuoi ottenere questa nave più avanti."
      },
      "resetIngame": {
        "info": "Un wipe ti toglie le navi acquistate in-game. Spostale nella tua lista dei desideri per riacquistarle in seguito, oppure rimuovile dal tuo hangar. Le navi che non hai acquistato in-game restano invariate."
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "alreadyRunning": "Una sincronizzazione dell'hangar è già in corso. Attendere il completamento.",
        "missingUnmatchedGroup": "Prima di iniziare, scegli il gruppo in cui archiviare le navi che la sincronizzazione non trova.",
        "signedOutTitle": "Non hai effettuato l'accesso a RSI",
        "signedOut": "Accedi al sito di RSI in questo browser, poi controlla di nuovo.",
        "sessionHint": "La sincronizzazione legge i tuoi pledge tramite questa sessione.",
        "finished": "Il tuo hangar corrisponde ai tuoi pledge RSI. Tutto è stato abbinato.",
        "unmatched": "Tutto il resto è stato sincronizzato. Niente di quanto elencato sotto è stato aggiunto al tuo hangar.",
        "partialFailure": "Alcune modifiche potrebbero essere già nel tuo hangar. Riprovare è sicuro: le navi già sincronizzate vengono abbinate di nuovo, non aggiunte due volte.",
        "pointMatch": "Trova le navi del tuo hangar RSI che sono già qui, per nome e ID del pledge.",
        "pointAdd": "Aggiunge quelle che non sono ancora qui."
      },
      "setEmail": "Per impostare una password, abilitare l'autenticazione a due fattori o ricevere notifiche via email, devi aggiungere un indirizzo email al tuo account. Riceverai un'email di conferma per verificare l'indirizzo.",
      "oauthApplications": {
        "pendingReview": "Questa applicazione è registrata e attende la revisione. Non può richiedere accessi finché non è approvata.",
        "rejected": "Questa applicazione è stata rifiutata e non può richiedere accessi. Correggere quanto indicato nel motivo la rimette in coda.",
        "returnedToReview": "Modificare l'URI di reindirizzamento o gli ambiti riporta in revisione un'applicazione approvata."
      },
      "payouts": {
        "accountFound": "%{username} ha un account FleetYards e verrà collegato a questo partecipante.",
        "accountMissing": "Nessun account FleetYards ha questo nome utente. Controlla come è scritto oppure aggiungilo qui sotto per nome come ospite.",
        "guestHint": "Per chi non ha un account FleetYards. Viene elencato come ospite.",
        "deleteHint": "Nessun altro partecipa ancora a questa spedizione, quindi può essere eliminata.",
        "tourInvite": "%{username} ti invita a unirti a questa spedizione.",
        "contractReady": "Il contratto è completato. Apri il suo registro dei pagamenti per pagare la ricompensa ai contraenti.",
        "contractNotReady": "Per questo contratto non è ancora stato aperto un registro dei pagamenti.",
        "expenseNeedsReview": "Una spesa conta dopo che chi gestisce il registro l'ha approvata."
      },
      "fleet": {
        "contractCovers": "L'immagine che la bacheca mostra per ogni tipo di contratto. Lasciandone una vuota viene usata l'immagine integrata qui sotto."
      },
      "vehicleLog": {
        "visibility": "Le voci pubbliche sono mostrate con questa nave nel tuo hangar pubblico.",
        "visibilityHidden": "Questa nave non compare nel tuo hangar pubblico, quindi lì non viene mostrata nessuna delle sue voci.",
        "empty": "Annota cosa è successo a questa nave: solo tu vedi una voce finché non la rendi pubblica.",
        "publicEmpty": "Il capitano di questa nave non ha ancora condiviso nessuna voce.",
        "noneForFilter": "Nessuna voce corrisponde a questo filtro.",
        "unavailable": "Questo diario non è disponibile al momento."
      },
      "vehiclePlaque": {
        "supporter": "Tutti gli altri stili sono un grazie a chi tiene in vita Fleetyards.",
        "keptStyle": "La tua targa mantiene lo stile %{style}, un vantaggio per chi ci sostiene. Salvando passerà a %{default}.",
        "credits": {
          "founders": "Fondatori di %{manufacturer}",
          "shipwrights": "Costruttori di %{manufacturer}",
          "designers": "Progettisti di %{manufacturer}",
          "directors": "Direzione di %{manufacturer}"
        },
        "fromFleet": "Da una flotta",
        "classLine": "%{model} di %{manufacturer}",
        "commissioned": "Commissionata a %{shipyard}",
        "launched": "Varata a %{date}",
        "launchedAt": "Varata a %{date}, %{port}",
        "launchedFrom": "Varata a %{port}",
        "captain": "Capitano %{name}",
        "captainOf": "Capitano %{name}, %{affiliation}",
        "year": "%{month} %{year}",
        "empty": "Ancora nessuna dedica. Scrivine una e la nave avrà la sua targa.",
        "visibility": "Finché questa nave è pubblica, chiunque può vedere la targa nel tuo hangar pubblico."
      },
      "vehicleOverview": {
        "noLoadouts": "Ancora nessun loadout. Collegane uno da Erkul o SPViewer.",
        "locationPrivate": "Solo tu puoi vedere dove si trova la tua nave.",
        "pickReplacesUpload": "Scegliere un'immagine dalla galleria o una verniciatura sostituisce quella che hai caricato.",
        "galleryEmpty": "Questa nave non ha ancora immagini nella galleria."
      },
      "model": {
        "sectionEmpty": "%{model} non ha %{section}."
      },
      "hangarPledgeItems": {
        "addToInventory": "Ognuno viene aggiunto tante volte quante il suo pledge lo contiene.",
        "alreadyInInventory": {
          "one": "%{count} elemento è già in un inventario e resta dov'è.",
          "other": "%{count} elementi sono già in un inventario e restano dove sono."
        },
        "noInventories": "Non hai ancora un inventario. Creane uno, poi aggiungi i tuoi elementi."
      },
      "plaqueTool": {
        "intro": "Dai a qualsiasi nave una targa di dedica. Scegli una nave, scrivi la sua dedica e condividi la targa come immagine.",
        "pickShip": "Scegli una nave per disegnarne la targa.",
        "signIn": "Accedi per mettere questa targa su una nave del tuo hangar.",
        "noShips": "Nel tuo hangar e nella tua lista dei desideri non c'è nessuna nave %{model} su cui mettere la targa.",
        "attachIntro": "La targa va sulla nave che scegli, con il nome e la matricola di quella nave.",
        "addShip": "Aggiungine una e riceverà la targa, con il nome e la matricola che le hai dato.",
        "example": "Un esempio: la targa che Cloud Imperium ha appeso per The Only Constant, il suo prototipo di Constellation Phoenix. Cambia una riga qualsiasi per renderla tua."
      }
    }
  }
}
